<template>
  <div id="rechargeRecords">
    <el-form :inline="true" class="">
      <el-form-item label="检测机构">
        <el-input v-model="merchantName" clearable placeholder="请输入检测机构关键字"></el-input>
      </el-form-item>
      <el-form-item label="充值时间">
        <el-date-picker v-model="rechargeDate" clearable type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
      </el-form-item>
      <el-form-item label="充值类型">
        <el-select v-model="rechargeChannel" clearable>
          <el-option v-for="channel in channels" :key="channel.value" :label="channel.desc" :value="channel.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值状态">
        <el-select v-model="rechargeStatus" clearable>
          <el-option v-for="status in statusList" :key="status.value" :label="status.desc" :value="status.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流水号">
        <el-input v-model="lsh" placeholder="请输入流水号关键字" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="listRecords">查询</el-button>
        <el-button type="primary" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="records" header-row-class-name="psh_table_header" row-class-name="psh_table_row" :border="true"
              :stripe="true">
      <el-table-column prop="id" label="序号" width="70"/>
      <el-table-column prop="merchantName" label="检测机构"/>
      <el-table-column prop="amount" label="充值金额" width="100"/>
      <el-table-column prop="createTime" label="充值时间" width="200"/>
      <el-table-column label="充值类型" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.channel === 1">支付宝扫码</span>
          <span v-else-if="scope.row.channel === 2">支付宝转账</span>
          <span v-else-if="scope.row.channel === 3">银行转账</span>
          <span v-else-if="scope.row.channel === 4">线下充值</span>
        </template>
      </el-table-column>
      <el-table-column label="交易流水" prop="lsh"/>
      <el-table-column label="充值状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" style="color:orange">未确认</span>
          <span v-else-if="scope.row.status === 2" style="color:forestgreen">已确认</span>
          <span v-else-if="scope.row.status === 3" style="color:#aaa">已取消</span>
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <span v-if="scope.row.cancelTime">取消时间：{{scope.row.cancelTime}}<br/></span>
          <span v-if="scope.row.cancelReason">取消原因：{{scope.row.cancelReason}}<br/></span>
          <span v-if="scope.row.cancelBy">取消人：{{scope.row.cancelBy}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 1" type="danger" size="small" @click="showConfirmDialog(scope.row)">确认</el-button>
          <el-button v-if="scope.row.status === 1" type="warning" size="small" @click="showCancelDialog(scope.row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange" style="text-align: right;margin-top: 25px;"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.pageNum"
      :page-sizes="[10, 20, 30, 100]"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
    </el-pagination>
    <el-dialog title="取消充值" :visible.sync="cancelDialogVisible">
      <el-form>
        <el-form-item v-if="cancelRecord">
          请输入取消<b style="color:red">{{cancelRecord.merchantName}}</b>在<b style="color:red">{{cancelRecord.createTime}}</b>充值的<b style="color:red">{{cancelRecord.amount}}</b>元的原因
        </el-form-item>
        <el-form-item >
          <el-input v-model="cancelReason" autocomplete="off" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="cancelDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="cancelRecharge(cancelRecord.id)">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="确认充值" :visible.sync="confirmDialogVisible">
      <el-form v-if="confirmRecord">
        <el-form-item label="检测机构：">
          {{ confirmRecord.merchantName }}
        </el-form-item>
        <el-form-item label="充值金额：">
          {{ confirmRecord.amount }}
        </el-form-item>
        <el-form-item label="充值方式：">
          <span v-if="confirmRecord.channel === 1">支付宝扫码</span>
          <span v-else-if="confirmRecord.channel === 2">支付宝转账</span>
          <span v-else-if="confirmRecord.channel === 3">银行转账</span>
          <span v-else-if="confirmRecord.channel === 4">线下充值</span>
        </el-form-item>
        <el-form-item label="充值时间：">
          {{ confirmRecord.createTime }}
        </el-form-item>
        <el-form-item label="流水号：">
          <el-col :span="11">
            <el-input type="text" placeholder="请输入订单流水号" v-model="confirmLsh"/>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="confirmDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmRecharge(confirmRecord.id)">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

  import {cancelRecharge, confirmRecharge, listRechargeRecords} from "../modules/services/basic-service";

export default {
  name: 'rechargeRecords',
  data () {
    return {
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      cancelReason: '',
      cancelDialogVisible: false,
      confirmDialogVisible: false,
      merchantName: '',
      records: [],
      rechargeDate: [],
      cancelRecord: null,
      confirmRecord: null,
      channels: [
        { 'value': 1, 'desc': '支付宝扫码'},
        { 'value': 2, 'desc': '支付宝转账'},
        { 'value': 3, 'desc': '银行转账'},
        { 'value': 4, 'desc': '线下充值'}
      ],
      statusList: [
        {'value': 1, 'desc': '未确认'},
        {'value': 2, 'desc': '已确认'},
        {'value': 3, 'desc': '已取消'}
      ],
      rechargeChannel: '',
      rechargeStatus: '',
      lsh: '',
      confirmLsh: ''
    }
  },
  methods: {
    showCancelDialog (record) {
      this.cancelRecord = record
      this.cancelDialogVisible = true
    },
    showConfirmDialog (record) {
      this.confirmRecord = record
      if (this.confirmRecord) {
        this.confirmDialogVisible = true
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.listRecords()
    },
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val
      this.listRecords()
    },
    cancelRecharge (id) {
      const self = this
      self.cancelRecord = null
      self.cancelDialogVisible = false
      let cancelReason = self.cancelReason
      self.cancelReason = ''
      cancelRecharge(id, cancelReason).then(({body}) => {
        if (body) {
          self.listRecords()
        }
      })
    },
    listRecords () {
      const self = this
      let from = this.rechargeDate ? this.rechargeDate[0] : ''
      let to = this.rechargeDate ? this.rechargeDate[1] : ''
      listRechargeRecords(this.pageInfo.pageNum, this.pageInfo.pageSize, from, to,
        this.rechargeStatus, this.merchantName, this.rechargeChannel, this.lsh).then(({body}) => {
        self.records = body.data
        self.pageInfo.total = body.total
      })
    },
    confirmRecharge (id) {
      const self = this
      self.confirmRecord = null
      self.confirmDialogVisible = false
      let confirmLsh = self.confirmLsh
      self.confirmLsh = ''
      confirmRecharge(id, confirmLsh).then(({body}) => {
        if (body) {
          self.listRecords()
        }
      })
    },
    reset(){
      this.rechargeDate=''
      this.rechargeChannel=''
      this.rechargeStatus=''
      this.merchantName=''
      this.lsh=''
    }
  },
  mounted () {
    this.listRecords()
  }
}
</script>

<style lang="stylus" scoped>
  #rechargeRecords {
    min-height: 700px;
  }
</style>